export default __webpack_public_path__ + "static/media/DNo.17-3.3ebc285b.jpg";